import type { ReactNode } from "react";
import defaultIcon from "../assets/images/default.svg";
import type { Language } from "../store/config";
import type { AcMenuItem, AcMenuLanguages } from "../types/acMenu";
import { parseAcMenuLanguages } from "./parseAcMenuLanguages";
import { toAcMenuRoutePath } from "./filterAcMenus";

export type DynamicSideMenuItem = {
  label: string;
  icon: string | ReactNode;
  path: string;
  menuID: string;
  visible: boolean;
  orderWeight: number;
  /** Remote or fallback SVG URL for <img> */
  iconSrc: string;
};

/** Use object key / path as-is; fall back to local default.svg when blank. */
export const resolveAcMenuIconUrl = (
  icon: string | null | undefined
): string => {
  const path = (icon || "").trim();
  return path || defaultIcon;
};

export function resolveAcMenuLabel(
  languages: AcMenuItem["languages"] | AcMenuLanguages | null | undefined,
  locale: Language
): string {
  const parsed = parseAcMenuLanguages(languages);
  const byLocale = parsed[locale];
  if (byLocale?.trim()) return byLocale.trim();
  return (parsed.en || "").trim();
}

export function mapAcModulesToMenuItems(
  modules: AcMenuItem[],
  locale: Language
): DynamicSideMenuItem[] {
  const sorted = [...modules].sort(
    (a, b) => (a.orderWeight ?? 0) - (b.orderWeight ?? 0)
  );
  return sorted.map((mod, index) => {
    const path = toAcMenuRoutePath(mod.name);
    const iconSrc = resolveAcMenuIconUrl(mod.icon);
    return {
      label: resolveAcMenuLabel(mod.languages, locale),
      icon: "",
      iconSrc,
      path,
      menuID: `ac-dyn-${mod.name || path || index}`,
      visible: true,
      orderWeight: mod.orderWeight ?? 0,
    };
  });
}
